// extracted by mini-css-extract-plugin
export default {"menu":"ProjectDetails_menu__DecPd","add":"ProjectDetails_add__zDhmo","locationRow":"ProjectDetails_locationRow__r8USa","date":"ProjectDetails_date__2Yrau"};